import React from 'react';
import PropTypes from 'prop-types';

const CalendarIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16">
        <path d="M14.259 1.529h-2.34V0h-1.307v1.529H5.388V0H4.082v1.529h-2.34A1.691 1.691 0 00.001 3.16v11.21a1.691 1.691 0 001.741 1.631h12.517A1.691 1.691 0 0016 14.37V3.159a1.691 1.691 0 00-1.741-1.63zM1.741 2.75h2.34v1.315h1.306V2.75h5.224v1.315h1.306V2.75h2.34a.423.423 0 01.435.408v3.4H1.306v-3.4a.423.423 0 01.435-.408zm12.518 12.027H1.741a.423.423 0 01-.435-.408v-6.59h13.388v6.59a.423.423 0 01-.435.408z" fill={fill} />
    </svg>
);

CalendarIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

CalendarIcon.defaultProps = {
    width: '16',
    height: '16',
    fill: '#4b254e'
};

export default CalendarIcon;
